<script>
import Signature from '@wielink-application/shared/vue/components/form/input-only/signature.vue'

export default Signature;
</script>